import React from "react";

const PlatformCtaSection = ({ data }) => (

    <section className="sx-platform-cta">

        <div className="container">

            <div className="sx-cta-box">

                <span>
                    {data.eyebrow}
                </span>

                <h2>
                    {data.title}
                    {data.highlight && (
                        <>
                            {" "}
                            <span>{data.highlight}</span>
                        </>
                    )}
                </h2>

                {data.description && (
                    <p>
                        {data.description}
                    </p>
                )}

                {data.button && (
                    <a
                        href={data.button.url}
                        className="sx-cta-button"
                    >
                        {data.button.label}
                    </a>
                )}

            </div>

        </div>

    </section>
);

export default PlatformCtaSection;